import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import DepartmentService from "../../../../services/DepartmentService";
import DesignationService from "../../../../services/DesignationService";
import { toast, ToastContainer } from "react-toastify";
import AsyncCreatableSelect from 'react-select/async-creatable';

const EmployeeForm = (props) => {
    const { register, handleSubmit, control, setValue, reset, formState: { errors }, watch } = useForm({
        defaultValues: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            gender: '',
            department_id: '',
            designation_id: '',
            customer_id: props.customerId || '',
            is_contact_person: false,
        }
    });
    const [departments, setDepartments] = useState([]);
    const [selectedDesignations, setSelectedDesignations] = useState([]);

    const onSubmit = async (data) => {
        try {
            props.onSubmit(data);
            reset();
        } catch (error) {
            console.log("Error in add contact person", error);
        }
    };

    const fetchDesignationOptions = async (departmentId = '', inputValue = '') => {
        if (!inputValue) return [];
        try {
            const response = await DesignationService.listAll({
                departmentId,
                search: inputValue,
            });
            if (response.status === 200 && response.data.success) {
                const designationData = response?.data?.data;
                return designationData.map(designation => ({
                    value: designation.id,
                    label: designation.name
                }))
            }

        } catch (error) {
            console.error("Error in get departments", error);
        }
    };

    const createNewDesignation = async (inputValue) => {
        try {

            const data = {
                name: inputValue,
                ...(watch('department_id') && { department_id: watch('department_id') })
            };
            const response = await DesignationService.create({ data });
            if (response.status === 201 && response.data.success) {
                const designationData = response?.data?.data;
                const newDesignation = { value: designationData.id, label: designationData.name };
                setSelectedDesignations(newDesignation);
                return newDesignation;
            }
        } catch (error) {
            console.warn("Error in create new designation", error);
            toast.error(error?.message || "An error occurred");
        }
    };

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await DepartmentService.listAll();
                const departmentData = response.data.data;
                setDepartments(departmentData);

                if (props.editData) {
                    const designationObject = props.editData?.designation
                        ? { value: props.editData.designation.id, label: props.editData.designation.name }
                        : null;
                    const formData = {
                        ...props.editData,
                        customer_id: props.customerId,
                        department_id: props.editData?.department?.id,
                        designation_id: props.editData?.designation?.id,
                    };
                    reset(formData);
                    setSelectedDesignations(designationObject);


                    // const selectedDepartment = departmentData.find(dept => dept.id === formData.department_id);
                    // setSelectedDesignations(selectedDepartment?.designations || []);
                }
            } catch (error) {
                console.error("Error in get departments", error);
            }
        };

        fetchDepartments();
    }, [props, reset]);

    useEffect(() => {
        if (props.customerId) {
            setValue('customer_id', props.customerId);
        }
    }, [props.customerId, setValue]);

    const handleDepartmentChange = (department_id) => {
        setValue('designation_id', '');
        if (!department_id) {
            setSelectedDesignations([]);
            return;
        }
        const selectedDepartment = departments.find(department => department.id === parseInt(department_id, 10));
        setSelectedDesignations(selectedDepartment?.designations || []);
    };

    const handlePhoneInputChange = (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
    };

    const handleCancel = () => {
        props.toggleView(props.tab, 'card');
    };

    return (
        <>
            <div className="container-fluid">
                <div className="card row p-4">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="row align-items-end">
                                <div className="col">
                                    <h2 className="header-title">{props.company}</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-body">
                        <form id="customer-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">First Name</label>
                                        <input
                                            type="text"
                                            {...register('first_name', {
                                                required: 'First name field is required.',
                                                validate: value => typeof value === 'string' || 'First Name must be a string'
                                            })}
                                            className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                                        />
                                        {errors.first_name && (
                                            <div className="text-danger">{errors.first_name.message}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Last Name</label>
                                        <input
                                            type="text"
                                            {...register('last_name', {
                                                validate: value => typeof value === 'string' || 'Last Name must be a string'
                                            })}
                                            className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                                        />
                                        {errors.last_name && (
                                            <div className="text-danger">{errors.last_name.message}</div>
                                        )}
                                    </div>
                                </div>

                                <input type="hidden" {...register('customer_id')} />

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Email address</label>
                                        <input
                                            type="email"
                                            {...register('email', {
                                                required: "The email field is required.",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: "Email must be a valid email address"
                                                }
                                            })}
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        />
                                        {errors.email && (
                                            <div className="invalid-feedback">{errors.email.message}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Phone no</label>
                                        <input
                                            type="tel"
                                            maxLength={10}
                                            {...register('phone', {
                                                required: "The phone number field is required.",
                                                minLength: {
                                                    value: 10,
                                                    message: "The phone number must be 10 digits number"
                                                },
                                                maxLength: {
                                                    value: 10,
                                                    message: "The phone number must be 10 digits number"
                                                },
                                                pattern: {
                                                    value: /^[0-9]+$/,
                                                    message: "Phone number must contain only digits"
                                                }
                                            })}
                                            onInput={handlePhoneInputChange}
                                            className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                        />
                                        {errors.phone && (
                                            <div className="text-danger">{errors.phone.message}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Gender</label>
                                        <Controller
                                            name="gender"
                                            control={control}
                                            rules={{ required: "Please select a gender" }}
                                            render={({ field }) => (
                                                <div>
                                                    {["male", "female", "other"].map(gender => (
                                                        <div className="form-check" key={gender}>
                                                            <input
                                                                {...field}
                                                                type="radio"
                                                                id={gender}
                                                                value={gender}
                                                                checked={field.value === gender}
                                                                className="form-check-input"
                                                            />
                                                            <label htmlFor={gender} className="form-check-label">
                                                                {gender.charAt(0).toUpperCase() + gender.slice(1)}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        />
                                        {errors.gender && (
                                            <span className="text-danger">{errors.gender.message}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Department</label>
                                        <Controller
                                            name="department_id"
                                            control={control}
                                            render={({ field }) => (
                                                <select
                                                    {...field}
                                                    value={field.value || ""}
                                                    onChange={(e) => {
                                                        const departmentId = e.target.value;
                                                        field.onChange(departmentId);
                                                        handleDepartmentChange(departmentId);
                                                    }}
                                                    className="form-select"
                                                >
                                                    <option value="">Select Department</option>
                                                    {departments.map((department) => (
                                                        <option key={department.id} value={department.id}>
                                                            {department.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        />
                                        {errors.department_id && (
                                            <div className="text-danger">{errors.department_id.message}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Designation</label>
                                        <Controller
                                            name="designation_id"
                                            control={control}
                                            render={({ field }) => (
                                                <AsyncCreatableSelect
                                                    {...field}
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={(inputValue) =>
                                                        fetchDesignationOptions(
                                                            watch("department_id") || "",
                                                            inputValue
                                                        )
                                                    }
                                                    onChange={(selectedOption) => {
                                                        setSelectedDesignations(selectedOption);
                                                        field.onChange(selectedOption ? selectedOption.value : null);
                                                    }}
                                                    onCreateOption={async (inputValue) => {
                                                        const newOption = await createNewDesignation(inputValue);
                                                        if (newOption) {
                                                            setSelectedDesignations(newOption);
                                                            field.onChange(newOption ? newOption.value : null);
                                                        }
                                                    }}
                                                    value={selectedDesignations || null}
                                                    placeholder="Select Designation"
                                                    isClearable
                                                />
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="form-group">
                                        <label className="form-label">Is Contact Person?</label>
                                        <Controller
                                            name="is_contact_person"
                                            control={control}
                                            render={({ field }) => (
                                                <div className="form-check">
                                                    <input
                                                        {...field}
                                                        type="checkbox"
                                                        id="is_contact_person"
                                                        className="form-check-input"
                                                        checked={field.value}
                                                    />
                                                    <label htmlFor="is_contact_person" className="form-check-label">
                                                        Yes
                                                    </label>
                                                </div>
                                            )}
                                        />
                                        {errors.is_contact_person && (
                                            <span className="text-danger">{errors.is_contact_person.message}</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger me-2"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-sm btn-primary">
                                    {props.editData?.id ? 'Update' : 'Save'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default EmployeeForm;